<template>
  <!-- eslint-disable max-len -->
  <path
    d="M5.5 1.1C4.9 1.1 4.4 1.4 4 1.8C3.6 2.2 3.4 2.8 3.4 3.3C3.4 4.2 3.9 5 4.8 5.3C5.6 5.6 6.6 5.4 7.2 4.8C7.8 4.2 8 3.2 7.7 2.4C7.2 1.7 6.4 1.1 5.5 1.1ZM5.5 6.7C5.1 6.7 4.6 6.6 4.2 6.4C3 5.9 2.2 4.7 2.2 3.3C2.2 2.4 2.5 1.6 3.2 1C3.9 0.4 4.6 0 5.5 0C6.9 0 8.1 0.8 8.6 2C9.1 3.2 8.9 4.7 7.9 5.6C7.3 6.3 6.4 6.7 5.5 6.7ZM1.2 11.9H9.9C9.6 9.7 7.7 8 5.5 8C3.3 8 1.4 9.7 1.2 11.9ZM11 13H0V12.4C0 9.3 2.4 6.8 5.5 6.8C8.5 6.8 11 9.3 11 12.4V13Z"
  />
</template>
